import {z as zod} from "zod";

export type ProductCatalogueWorkspaceCapabilityConfiguration = Record<string, never>;

export const productCatalogueWorkspaceCapabilityConfigurationValidator: zod.ZodType<ProductCatalogueWorkspaceCapabilityConfiguration> = zod.strictObject({});
